import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterLink } from '@angular/router';

import { SiteMap } from './site-map.model';
import { ContainerComponent } from '../../shared/components/container/container.component';
import { ReviewBarComponent } from '../../shared/components/review-bar/review-bar.component';

interface SiteMapGroup {
  heading: string;
  links: SiteMap[];
}

@Component({
  selector: 'sitemap',
  imports: [CommonModule, RouterLink, ContainerComponent, ReviewBarComponent],
  templateUrl: './sitemap.component.html',
  styleUrl: './sitemap.component.scss',
})
export class SitemapComponent {
  routes: SiteMap[] = [];
  homeRoute?: SiteMap;
  routeGroups: SiteMapGroup[] = [];
  howToScreenRoute?: SiteMap;

  constructor(private router: Router) {
    this.router.config.forEach((route) => {
      if (route.data) {
        //get sitemap data from route
        let sitemapData = route.data['sitemap'];

        //if there's sitemap data, then route is added to list
        if (sitemapData) {
          //route object

          let routeObj: SiteMap = {
            text: sitemapData.text,
            href: false,
            url: `/${route.path}`,
            fragments: [],
            main: sitemapData.text === 'Home',
          };

          //add fragments if required
          if (sitemapData.fragments) {
            sitemapData.fragments.forEach((fragment: any) => {
              routeObj.fragments?.push({
                text: fragment.text,
                url: `/${route.path}`,
                fragment: fragment.fragment,
              });
            });
          }

          //add to list
          this.routes.push(routeObj);
        }
      }
    });

    this.homeRoute = this.getRoute('Home');
    this.howToScreenRoute = this.getRoute('How to screen');
    this.routeGroups = [
      {
        heading: 'Know your risk',
        links: this.getRoutes([
          'What’s your type 1 diabetes risk?',
          'What is early-stage type 1 diabetes?',
        ]),
      },
      {
        heading: 'Why screen?',
        links: this.getRoutes([
          'The costs of not knowing',
          'The benefits of knowing',
          'The family history survey',
        ]),
      },
      {
        heading: 'Resources',
        links: this.getRoutes(['Make a plan and FAQs', 'Sign up for updates']),
      },
      {
        heading: 'For Healthcare Providers',
        links: this.getRoutes([
          'Early Detection Matters',
          'T1D and Family History',
          'HCP Resources',
        ]),
      },
    ];
  }

  private getRoute(text: string): SiteMap | undefined {
    return this.routes.find((route) => route.text === text);
  }

  private getRoutes(texts: string[]): SiteMap[] {
    return texts
      .map((text) => this.getRoute(text))
      .filter((route): route is SiteMap => !!route);
  }
}
